/* eslint-disable func-names */
/* eslint-disable prefer-destructuring */
/* eslint-disable class-methods-use-this */
import ScreenLock from '../__constants/lock-screen';

const $ = jQuery.noConflict();

class StorePopup {
    constructor() {
        this.mainSlider = '.product-popup__slider';
        this.qtyCopy = '.qty-copy';
    }

    init() {
        this.slider();
        this.closeEvent();
        this.qty();
        this.setPrice();
    }

    slider() {
        $(this.mainSlider).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            adaptiveHeight: true,
        });

        $('.product-popup__thumbnails-single').on('click', (event) => {
            const thumbnail = $(event.currentTarget);
            thumbnail.parent().prev().slick('slickGoTo', thumbnail.index());
        });
    }

    closeEvent() {
        $('.product-popup-overlay, .product-popup__close').on('click', () => {
            $('.product-popup-overlay').removeClass('active');
            $('.product-popup.active').removeClass('active');
            ScreenLock.unlock();
        });
    }

    twoDecimalPlaces(value) {
        return (Math.round(value * 100) / 100).toFixed(2);
    }

    qty() {
        $(this.qtyCopy).on('change', (event) => {
            const value = $(event.currentTarget).val();
            const form = $(event.currentTarget).closest('form');
            form.find('input.qty').val(value);
            const priceEl = form.find('.woocommerce-variation-price');
            const price = (priceEl.text().match(/\d*(\.\d+)/g)[0]);
            form.prev().find('.price').text(`$${this.twoDecimalPlaces(price * value)} AUD`);
        });
    }

    setPrice() {
        const twoDecimalPlaces = this.twoDecimalPlaces;

        $('.variations_form').each(function () {
            $(this).on('found_variation', (event, variation) => {
                const price = variation.display_price;
                const form = $(event.currentTarget[0]).closest('form');
                form.find('input.qty-copy').val(1);
                form.prev().find('.price').text(`$${twoDecimalPlaces(price)} AUD`);
            });
        });
    }
}

export default new StorePopup();
